"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _defaultProps = _interopRequireDefault(require("recompose/defaultProps"));

var _pure = _interopRequireDefault(require("recompose/pure"));

var _withPropsOnChange = _interopRequireDefault(require("recompose/withPropsOnChange"));

var _setDisplayName = _interopRequireDefault(require("recompose/setDisplayName"));

var _core = require("@nivo/core");

var _colors = require("@nivo/colors");

var _props = require("./props");

var _PieSlice = _interopRequireDefault(require("./PieSlice"));

var _PieRadialLabels = _interopRequireDefault(require("./PieRadialLabels"));

var _PieSlicesLabels = _interopRequireDefault(require("./PieSlicesLabels"));

var _PieLayout = _interopRequireDefault(require("./PieLayout"));

var _PieLegends = _interopRequireDefault(require("./PieLegends"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
class Pie extends _react.Component {
  render() {
    const _this$props = this.props,
          data = _this$props.data,
          sortByValue = _this$props.sortByValue,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          padAngle = _this$props.padAngle,
          fit = _this$props.fit,
          innerRadius = _this$props.innerRadius,
          cornerRadius = _this$props.cornerRadius,
          margin = _this$props.margin,
          width = _this$props.width,
          height = _this$props.height,
          outerWidth = _this$props.outerWidth,
          outerHeight = _this$props.outerHeight,
          colors = _this$props.colors,
          colorBy = _this$props.colorBy,
          borderWidth = _this$props.borderWidth,
          _borderColor = _this$props.borderColor,
          enableRadialLabels = _this$props.enableRadialLabels,
          getRadialLabel = _this$props.getRadialLabel,
          radialLabelsSkipAngle = _this$props.radialLabelsSkipAngle,
          radialLabelsLinkOffset = _this$props.radialLabelsLinkOffset,
          radialLabelsLinkDiagonalLength = _this$props.radialLabelsLinkDiagonalLength,
          radialLabelsLinkHorizontalLength = _this$props.radialLabelsLinkHorizontalLength,
          radialLabelsLinkStrokeWidth = _this$props.radialLabelsLinkStrokeWidth,
          radialLabelsTextXOffset = _this$props.radialLabelsTextXOffset,
          radialLabelsTextColor = _this$props.radialLabelsTextColor,
          radialLabelsLinkColor = _this$props.radialLabelsLinkColor,
          enableSlicesLabels = _this$props.enableSlicesLabels,
          getSliceLabel = _this$props.getSliceLabel,
          slicesLabelsSkipAngle = _this$props.slicesLabelsSkipAngle,
          slicesLabelsTextColor = _this$props.slicesLabelsTextColor,
          theme = _this$props.theme,
          defs = _this$props.defs,
          fill = _this$props.fill,
          isInteractive = _this$props.isInteractive,
          onClick = _this$props.onClick,
          onMouseEnter = _this$props.onMouseEnter,
          onMouseLeave = _this$props.onMouseLeave,
          tooltipFormat = _this$props.tooltipFormat,
          tooltip = _this$props.tooltip,
          legends = _this$props.legends;
    const borderColor = (0, _colors.getInheritedColorGenerator)(_borderColor, theme);
    return _react.default.createElement(_PieLayout.default, {
      width: width,
      height: height,
      data: data,
      sortByValue: sortByValue,
      startAngle: startAngle,
      endAngle: endAngle,
      fit: fit,
      padAngle: padAngle,
      innerRadius: innerRadius,
      cornerRadius: cornerRadius,
      colors: colors,
      colorBy: colorBy
    }, ({
      centerX,
      centerY,
      radius,
      innerRadius,
      arcs,
      arcGenerator
    }) => {
      const boundDefs = (0, _core.bindDefs)(defs, arcs, fill, {
        dataKey: 'data'
      });
      return _react.default.createElement(_core.Container, {
        isInteractive: isInteractive,
        theme: theme,
        animate: false
      }, ({
        showTooltip,
        hideTooltip
      }) => _react.default.createElement(_core.SvgWrapper, {
        width: outerWidth,
        height: outerHeight,
        margin: margin,
        defs: boundDefs,
        theme: theme
      }, _react.default.createElement("g", {
        transform: "translate(" + centerX + "," + centerY + ")"
      }, arcs.map(arc => _react.default.createElement(_PieSlice.default, {
        key: arc.data.id,
        data: arc.data,
        path: arcGenerator(arc),
        color: arc.color,
        fill: arc.fill ? arc.fill : arc.color,
        borderWidth: borderWidth,
        borderColor: borderColor(arc),
        showTooltip: showTooltip,
        hideTooltip: hideTooltip,
        tooltipFormat: tooltipFormat,
        tooltip: tooltip,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        theme: theme
      })), enableRadialLabels && _react.default.createElement(_PieRadialLabels.default, {
        arcs: arcs,
        radius: radius,
        label: getRadialLabel,
        skipAngle: radialLabelsSkipAngle,
        linkOffset: radialLabelsLinkOffset,
        linkDiagonalLength: radialLabelsLinkDiagonalLength,
        linkHorizontalLength: radialLabelsLinkHorizontalLength,
        linkStrokeWidth: radialLabelsLinkStrokeWidth,
        textXOffset: radialLabelsTextXOffset,
        textColor: (0, _colors.getInheritedColorGenerator)(radialLabelsTextColor, theme),
        linkColor: (0, _colors.getInheritedColorGenerator)(radialLabelsLinkColor, theme),
        theme: theme
      }), enableSlicesLabels && _react.default.createElement(_PieSlicesLabels.default, {
        arcs: arcs,
        radius: radius,
        innerRadius: innerRadius,
        theme: theme,
        label: getSliceLabel,
        skipAngle: slicesLabelsSkipAngle,
        textColor: (0, _colors.getInheritedColorGenerator)(slicesLabelsTextColor, theme)
      })), _react.default.createElement(_PieLegends.default, {
        width: width,
        height: height,
        arcs: arcs,
        legends: legends,
        theme: theme
      })));
    });
  }

}

Pie.propTypes = process.env.NODE_ENV !== "production" ? _props.PiePropTypes : {};

const enhance = Component => (0, _compose.default)((0, _defaultProps.default)(_props.PieDefaultProps), (0, _core.withTheme)(), (0, _core.withDimensions)(), (0, _withPropsOnChange.default)(['radialLabel'], ({
  radialLabel
}) => ({
  getRadialLabel: (0, _core.getLabelGenerator)(radialLabel)
})), (0, _withPropsOnChange.default)(['sliceLabel'], ({
  sliceLabel
}) => ({
  getSliceLabel: (0, _core.getLabelGenerator)(sliceLabel)
})), _pure.default)(Component);

var _default = (0, _setDisplayName.default)('Pie')(enhance(Pie));

exports.default = _default;
module.exports = exports.default;